export default __webpack_public_path__ + "static/media/icon_logout.85962a5b.svg";